<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="拠点ID、拠点名、ふりがな、電話番号、住所、補足情報から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="placeFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="places"
      :router="router"
      @remove="remove"
      @import="importModal"
      @exportFile="exportFile"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'
import * as XLSX from 'xlsx-js-style'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/places/add',
      showloadingModal: false,
      showImportModal: false,
      excelData: null,
      confirmed: ''
    }
  },
  computed: {
    places() {
      return this.$store.state.places.locations
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedLocationList() {
      return this.$store.state.places.selectedLocationList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedLocationList = this.selectedLocationList.map((loc) => {
        let userId = loc.userId
        let deviceId = loc.deviceId
        return {userId, deviceId}
      })
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'places/deleteLocations',
          selectedLocationList
        )
        this.$store.dispatch('places/clearSelectedLocationList')
        this.finishWord = '対象の拠点を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/places') {
          this.$router.push('/places')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_170003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0030') {
            this.finishWord =
              this.errorMsg.MSGCRC0030.name +
              this.errorMsg.MSGCRC0030.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0298') {
            this.finishWord =
              this.errorMsg.MSGCRC0298.name +
              this.errorMsg.MSGCRC0298.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0030'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0030.name +
            this.errorMsg.MSGCRC0030.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    placeFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    importModal(data) {
      this.excelData = data
      this.showImportModal = true
    },
    async importFile() {
      this.showImportModal = false
      this.showloadingModal = true
      var createList = []
      setTimeout(async () => {
        try {
          const excelDataList = this.loadExcelData(this.excelData)
          createList = createList.concat(excelDataList)
        } catch (error) {
          this.showloadingModal = false
          return
        }
        if (location.pathname !== '/places') {
          this.$router.push('../places')
        }
        try {
          await this.$store.dispatch('places/importLocations', createList)
          this.$emit('list-reload')
          this.finishWord = 'インポートしました。'
          this.showFinishModal = true
        } catch (error) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_170009
          let eventType = 3
          let reason = ''
          if (
            error.response &&
            error.response.data &&
            error.response.data.header &&
            error.response.data.header.message
          ) {
            let errorMessage = error.response.data.header.message.split(',')
            if (errorMessage[0] === 'MSGCRC0023') {
              this.finishWord =
                this.errorMsg.MSGCRC0023.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0023.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0024') {
              this.finishWord =
                this.errorMsg.MSGCRC0024.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0024.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0092') {
              this.finishWord =
                this.errorMsg.MSGCRC0092.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0092.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0098') {
              this.finishWord =
                this.errorMsg.MSGCRC0098.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0098.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0099') {
              this.finishWord =
                this.errorMsg.MSGCRC0099.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0099.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0100') {
              this.finishWord =
                this.errorMsg.MSGCRC0100.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0100.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0124') {
              this.finishWord =
                this.errorMsg.MSGCRC0124.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0124.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0130') {
              this.finishWord =
                this.errorMsg.MSGCRC0130.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0130.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0170') {
              this.finishWord =
                this.errorMsg.MSGCRC0170.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0170.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0171') {
              this.finishWord =
                this.errorMsg.MSGCRC0171.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0171.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0273') {
              this.finishWord =
                this.errorMsg.MSGCRC0273.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0273.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0206') {
              this.finishWord =
                this.errorMsg.MSGCRC0206.name +
                errorMessage[1] +
                '行目：' +
                this.errorMsg.MSGCRC0206.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0185') {
              this.finishWord =
                this.errorMsg.MSGCRC0185.name +
                (Number(errorMessage[1]) + 1) +
                this.errorMsg.MSGCRC0185.beforeValue +
                errorMessage[1] +
                this.errorMsg.MSGCRC0185.afterValue +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else if (errorMessage[0] === 'MSGCRC0264') {
              this.finishWord =
                this.errorMsg.MSGCRC0264.name +
                this.errorMsg.MSGCRC0264.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              this.finishWord =
                this.errorMsg.MSGCRC0031.name +
                this.errorMsg.MSGCRC0031.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            reason = errorMessage[0] + ' '
            reason += error.response.status
          } else {
            reason = 'MSGCRC0005'
            eventType = 9
            this.finishWord =
              this.errorMsg.MSGCRC0005.name +
              this.errorMsg.MSGCRC0005.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.showFinishModal = true
        }
        this.showloadingModal = false
      }, 100)
    },
    loadExcelData(excelData) {
      const createList = []
      let workbook
      let excelRows
      try {
        workbook = XLSX.read(excelData, {type: 'array'})
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        if (!worksheet) throw new Error('no worksheet')
        excelRows = XLSX.utils.sheet_to_json(worksheet, {
          defval: '',
          raw: false
        })
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_510003
        let eventType = 9
        let reason = 'MSGCRC0314'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (e) {}
        this.finishWord =
          this.errorMsg.MSGCRC0314.name +
          this.errorMsg.MSGCRC0314.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFinishModal = true
        this.showloadingModal = false
        throw new Error()
      }
      if (excelRows.length === 0) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_510002
        let eventType = 9
        let reason = 'MSGCRC0010'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.finishWord =
          this.errorMsg.MSGCRC0010.name +
          this.errorMsg.MSGCRC0010.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFinishModal = true
        this.showloadingModal = false
        throw new Error()
      }
      for (let i = 0; i < excelRows.length; i++) {
        const row = excelRows[i]
        if (!row || Object.keys(row).length === 0) continue
        if (
          !this.$store.state.error.excelColumn.place.every((key) => key in row)
        ) {
          let eventNumber = this.$store.state.error.errorCode.errorCode_170007
          let eventType = 9
          let reason = 'MSGCRC0008'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0008.name +
            this.errorMsg.MSGCRC0008.beforeValue +
            // キーの情報がない=ヘッダ情報がないとみなし、1に固定
            1 +
            this.errorMsg.MSGCRC0008.afterValue +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          throw new Error()
        }
        let obj = {}
        obj['userId'] = row.拠点ID
        obj['userName'] = row.拠点名
        obj['pronunciation'] = row.ふりがな
        obj['phoneNumber'] = row.電話番号
        obj['locationAddress'] = row.住所
        obj['fileRowCount'] = String(i + 2)
        obj['memo'] = row.補足情報
        obj['foothold'] = true
        createList.push(obj)
      }
      return createList
    },
    async exportFile() {
      var selectedLocationIdList = this.selectedLocationList.map((location) => {
        return {placeId: location.userId}
      })
      this.showloadingModal = true
      try {
        const params = {selectedLocationIdList: selectedLocationIdList}
        if (selectedLocationIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('places/setExportData', params)

        const exportList = this.$store.state.places.exportData
        let result = [this.$store.state.error.excelColumn.place]
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k]) {
              exportList[i][k] = ''
            }
          }
          result.push([
            exportList[i].placeId,
            exportList[i].placeName,
            exportList[i].pronunciation,
            exportList[i].phoneNumber,
            exportList[i].locationAddress,
            exportList[i].memo
          ])
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_170008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }

        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.aoa_to_sheet(result)

        const ref = worksheet['!ref']
        if (!ref) return
        const range = XLSX.utils.decode_range(ref)

        for (let row = range.s.r; row <= range.e.r; row++) {
          for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({r: row, c: col})
            const cell = worksheet[cellAddress]
            if (!cell) continue
            // 文字列設定
            cell.t = 's'
            cell.z = '@'
          }
        }

        XLSX.utils.book_append_sheet(workbook, worksheet, '拠点')
        const data = XLSX.write(workbook, {
          type: 'buffer',
          bookSST: true,
          bookType: 'xlsx',
          compression: true
        })

        let link = document.createElement('a')
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          window.navigator.msSaveOrOpenBlob(blob, '拠点一覧.xlsx')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          link.setAttribute('download', '拠点一覧.xlsx')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          link.setAttribute('download', '拠点一覧.xlsx')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_170005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_170006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0032 '
          this.finishWord =
            this.errorMsg.MSGCRC0032.name +
            this.errorMsg.MSGCRC0032.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/places/controlbar.vue